module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-011.9e264d11.jpg";